import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminTable } from "./AdminTable";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { toast } from "sonner";

const STATUSES = ["pending", "confirmed", "completed", "cancelled"];

export default function AdminConsultations() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/consultations").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const changeStatus = async (r, status) => {
    await api.patch(`/admin/consultations/${r.id}`, { status });
    toast.success(`Marked ${status}`); load();
  };

  const del = async (r) => {
    if (!window.confirm(`Delete booking for ${r.name}?`)) return;
    await api.delete(`/admin/consultations/${r.id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-consultations">
      <h1 className="font-serif text-4xl">Consultations</h1>
      <p className="text-foreground/60 mb-6 mt-1">Manage booking requests.</p>

      <AdminTable
        testIdPrefix="c-row"
        columns={[
          { key: "name", label: "Client" },
          { key: "category", label: "Category" },
          { key: "date", label: "Date" },
          { key: "slot", label: "Slot" },
          { key: "email", label: "Contact", render: (r) => <div><div className="text-xs">{r.email}</div><div className="text-xs text-foreground/60">{r.phone}</div></div> },
          { key: "status", label: "Status", render: (r) => (
            <Select value={r.status} onValueChange={(v) => changeStatus(r, v)}>
              <SelectTrigger className="w-36 rounded-full text-xs" data-testid={`status-${r.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          ) },
        ]}
        rows={rows}
        onDelete={del}
      />
    </div>
  );
}
